module.exports = __webpack_public_path__ + "static/jinx_768w_q50-2d137999b6e487b74e1509633e51db59.webp";